export default {
  install (Vue) {
    Vue.prototype.$danmaku = window.danmaku
  }
}



// WEBPACK FOOTER //
// ./src/plugins/VueDanmaku.js